<script>
    import {cartItemsStore, decrementItemInCart, incrementItemInCart} from "../cart/cart-store.js";
    import {onDestroy} from "svelte";
    import {t} from "../core/i18n/language-store.js";

    export let record;
    export let price;
    export let publishConfig;

    let showAll;
    let cartIsEmpty = false;
    let cartHasRecord = false;

    const storeSubscriptions = [
        cartItemsStore.subscribe(items => {
            cartIsEmpty = (items || []).length === 0;
            cartHasRecord = (items || []).filter(x => x.id === record.id).length > 0;
        })
    ];

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>
    .added-item {
        color: var(--main-font-color);
        background: var(--cart-item-preview-bg);
        margin-top: .5rem;
        padding: 0.375rem 0.5rem;
        border-top-left-radius: .75rem;
        border-bottom-right-radius: .75rem;
    }
    .inc-button {
        line-height: 1;
        font-size: var(--fs-100);
        color: var(--price-item-bg-color);
        display: inline-flex;
        border: none;
        background: none;
    }
    .not-in-cart {
        padding: .5em 0;
    }
</style>

{#if (!cartIsEmpty)}
    <div>
        <div class="flex-between">
            <strong>{$t('cart.title')}:</strong>
            <span class="fs-85" style="opacity: 0.35;">
                <span class:underline={!showAll} on:click={() => showAll = false}>{ record.name || $t('cart.unnamed') }</span> | <span class:underline={showAll} on:click={() => showAll = true}>{$t('cart.all')}</span>
            </span>
        </div>
        <ul>
            {#if (!showAll && !cartHasRecord)}
                <li class="not-in-cart">{ record.name || $t('cart.unnamed') } {$t('cart.notInCart')}</li>
            {/if}
            {#each $cartItemsStore as cartItem}
                {#if (showAll || record.id === cartItem.id)}
                    <li class="added-item scale-in-animation">
                        <div class="flex-between ai-center fs-90 lh-1">
                            <div class="flex-fill">

                                <strong class="wrap-anywhere">{ cartItem.name || $t('cart.unnamed') }</strong>

                                {#if (cartItem.weight)}
                                    <span class="wrap-anywhere">{ cartItem.weight }</span>
                                {/if}

                                <br>

                                {#if (cartItem.modsDescription?.length > 0)}
                                    <span class="wrap-anywhere">
                                        ({ cartItem?.modsDescription })
                                    </span>
                                {/if}

                                <strong class="price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                                    <span>{ cartItem.price || '-' }</span>
                                    <span>{ publishConfig?.currency }</span>
                                </strong>
                            </div>
                            <div class="flex ai-center">
                                <button class="inc-button pointer" on:click={decrementItemInCart({id: cartItem.id}, price, cartItem.priceIndex, cartItem.mods)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
                                </button>

                                <strong>{ cartItem.count }</strong>

                                <button class="inc-button pointer" on:click={incrementItemInCart({id: cartItem.id}, price, cartItem.priceIndex, cartItem.mods)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                                </button>
                            </div>
                        </div>
                    </li>
                {/if}
            {/each}
        </ul>
    </div>
{/if}
